import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;

import TAOS from "./../Taos";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVideoModalOpen: false
    };
  }

  static defaultProps = {
    more: true
  };

  openVideoModal = () => {
    this.setState({ isVideoModalOpen: true });
  };

  closeVideoModal = () => {
    this.setState({ isVideoModalOpen: false });
  };

  // Функция для извлечения ID видео из URL Rutube
  getRutubeVideoId = (url) => {
    if (!url) return '';
    const match = url.match(/\/video\/([a-zA-Z0-9]+)/);
    return match ? match[1] : '';
  };

  render() {
    const { more } = this.props;
    const { isVideoModalOpen } = this.state;
    const data = this.props?.data || {};
    const block_about = data?.block_about || {};
    
    const videoId = this.getRutubeVideoId(block_about?.video);
    const embedUrl = videoId ? `https://rutube.ru/play/embed/${videoId}` : '';

    return (
      <div className='mt-[70px] xl:mt-[80px] max-w-full'>
        <div className='container'>
          <div className='flex items-center gap-[10px] text-[14px]'>
            <div className='w-full text-center xl:text-start'>
              <div className='inline-flex items-center justify-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.75 16.5H3.75C2.25 16.5 1.5 15.75 1.5 14.25V8.25C1.5 6.75 2.25 6 3.75 6H7.5V14.25C7.5 15.75 8.25 16.5 9.75 16.5Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7.58249 3C7.52249 3.225 7.5 3.4725 7.5 3.75V6H3.75V4.5C3.75 3.675 4.425 3 5.25 3H7.58249Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10.5 6V9.75" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M13.5 6V9.75" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.75 12.75H11.25C10.8375 12.75 10.5 13.0875 10.5 13.5V16.5H13.5V13.5C13.5 13.0875 13.1625 12.75 12.75 12.75Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4.5 9.75V12.75" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7.5 14.25V3.75C7.5 2.25 8.25 1.5 9.75 1.5H14.25C15.75 1.5 16.5 2.25 16.5 3.75V14.25C16.5 15.75 15.75 16.5 14.25 16.5H9.75C8.25 16.5 7.5 15.75 7.5 14.25Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='tracking-[-0.04em] text-[#032432]/60 text-[14px] xl:text-[16px]'>О нашей компании</div>
              </div>
            </div>
          </div>
          <div className='flex flex-col xl:flex-row items-center xl:items-end justify-between gap-[20px] text-[14px] mt-[10px]'>
            <h2 className='font-medium mt-[20px] xl:mt-[30px] tracking-[-0.04em] text-[#032432] text-[24px] xl:text-[36px] leading-none text-center xl:text-start'>{Parser(block_about?.title)}</h2>
            {more &&
              <a href={block_about?.more} className='flex items-center gap-[9px]'>
                <div className='text-[#032432]/60 whitespace-nowrap'>Подробнее</div>
                <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.433105 0.25L3.60234 5.75L0.433105 11.25" stroke="#032432" stroke-opacity="0.6"/>
                </svg>
              </a>
            }
          </div>
          <TAOS
            as="div"
            className='
              flex flex-col xl:flex-row gap-[10px] mt-[30px] items-start
              delay-[100ms] duration-[600ms] taos:translate-x-[100%] taos:opacity-0
            '
            offset="400"
          >
            <div className='p-[20px] rounded-[15px] bg-[#F5F7F9] w-full xl:w-[264px] xl:min-h-[240px] h-full tracking-[-0.04em] leading-none'>
              <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[33px] w-full'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.48047 18.3505L10.5805 20.7505C10.9805 21.1505 11.8805 21.3505 12.4805 21.3505H16.2805C17.4805 21.3505 18.7805 20.4505 19.0805 19.2505L21.4805 11.9505C21.9805 10.5505 21.0805 9.35046 19.5805 9.35046H15.5805C14.9805 9.35046 14.4805 8.85046 14.5805 8.15046L15.0805 4.95046C15.2805 4.05046 14.6805 3.05046 13.7805 2.75046C12.9805 2.45046 11.9805 2.85046 11.5805 3.45046L7.48047 9.55046" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M2.38281 18.3504V8.55039C2.38281 7.15039 2.98281 6.65039 4.38281 6.65039H5.38281C6.78281 6.65039 7.38281 7.15039 7.38281 8.55039V18.3504C7.38281 19.7504 6.78281 20.2504 5.38281 20.2504H4.38281C2.98281 20.2504 2.38281 19.7504 2.38281 18.3504Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='text-[#032432] text-[16px] xl:text-[18px]'>{Parser(block_about?.title_b1)}</div>
              </div>
              <div className='mt-[10px] text-black/60 text-[14px] xl:text-[16px]'>{Parser(block_about?.text_b1)}</div>
            </div>
            <div className='p-[20px] rounded-[15px] bg-[#032432] w-full xl:w-[229px] xl:min-h-[240px] h-full tracking-[-0.04em] leading-none'
              style={{
                backgroundImage: 'url("/assets/images/about_c_bg.svg")',
                backgroundSize: 'cover'
              }}
            >
              <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[33px] w-full'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.70001 18H4.15002C2.72002 18 2 17.28 2 15.85V4.15002C2 2.72002 2.72002 2 4.15002 2H8.45001C9.88001 2 10.6 2.72002 10.6 4.15002V6" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M17.3692 8.41998V19.58C17.3692 21.19 16.5692 22 14.9592 22H9.1192C7.5092 22 6.69922 21.19 6.69922 19.58V8.41998C6.69922 6.80998 7.5092 6 9.1192 6H14.9592C16.5692 6 17.3692 6.80998 17.3692 8.41998Z" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M13.3984 6V4.15002C13.3984 2.72002 14.1184 2 15.5484 2H19.8484C21.2784 2 21.9984 2.72002 21.9984 4.15002V15.85C21.9984 17.28 21.2784 18 19.8484 18H17.3684" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10 11H14" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10 14H14" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 22V19" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='text-white text-[16px] xl:text-[18px]'>{Parser(block_about?.title_b2)}</div>
              </div>
              <div className='mt-[10px] text-white/60 text-[14px] xl:text-[16px]'>{Parser(block_about?.text_b2)}</div>
            </div>
            <div className='p-[20px] rounded-[15px] bg-[#F5F7F9] w-full xl:w-[268px] xl:min-h-[240px] h-full tracking-[-0.04em] leading-none'>
              <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[33px] w-full'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 9V7C2 4 4 2 7 2H17C20 2 22 4 22 7V9" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 15V17C2 20 4 22 7 22H17C20 22 22 20 22 17V15" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.69922 9.25977L11.9992 12.3298L17.2592 9.27979" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 17.7703V12.3203" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10.7622 6.28859L7.56218 8.06862C6.84218 8.46862 6.24219 9.47861 6.24219 10.3086V13.6986C6.24219 14.5286 6.83218 15.5386 7.56218 15.9386L10.7622 17.7186C11.4422 18.0986 12.5622 18.0986 13.2522 17.7186L16.4522 15.9386C17.1722 15.5386 17.7722 14.5286 17.7722 13.6986V10.3086C17.7722 9.47861 17.1822 8.46862 16.4522 8.06862L13.2522 6.28859C12.5622 5.89859 11.4422 5.89859 10.7622 6.28859Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='text-[#032432] text-[16px] xl:text-[18px]'>{Parser(block_about?.title_b3)}</div>
              </div>
              <div className='mt-[10px] text-black/60 text-[14px] xl:text-[16px]'>{Parser(block_about?.text_b3)}</div>
            </div>
            
            {/* Превью видео с обработчиком клика */}
            <div 
              onClick={this.openVideoModal}
              className='relative cursor-pointer group xl:min-h-[240px] flex-1'
            >
              <div className='absolute top-[10px] left-[10px] flex items-center gap-[5px] px-[10px] rounded-full h-[38px] bg-white/20 z-10'>
                <img src='/assets/images/rutube.svg' alt='rt' width={18} height={18} className='flex-none h-auto' />
                <div className='text-[14px] xl:text-[16px] text-white tracking-[-0.04em]'>Мы на Rutube</div>
              </div>
              <div className='absolute flex w-full h-full top-0 left-0 items-center justify-center z-10 group-hover:scale-110 transition-transform duration-300'>
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z" fill="#009EE3"/>
                  <path d="M11.25 15.0012V12.9547C11.25 10.3135 12.9878 9.2487 15.1117 10.5624L16.7594 11.5857L18.407 12.609C20.531 13.9226 20.531 16.0798 18.407 17.3935L16.7594 18.4168L15.1117 19.4401C12.9878 20.7538 11.25 19.6752 11.25 17.0478V15.0012Z" fill="white"/>
                </svg>
              </div>
              <img 
                src={block_about?.poster} 
                alt={`video preview`} 
                width={389} 
                height={203} 
                className='group-hover:opacity-90 transition-opacity duration-300 w-full h-auto xl:h-[240px] object-cover rounded-[15px]'
              />
            </div>
          </TAOS>
        </div>

        {/* Модальное окно с видео */}
        {isVideoModalOpen && (
          <div 
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
            onClick={this.closeVideoModal}
          >
            <div 
              className="relative w-full max-w-4xl bg-black rounded-xl overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Кнопка закрытия */}
              <button 
                onClick={this.closeVideoModal}
                className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-black/50 hover:bg-black/70 flex items-center justify-center transition-colors duration-200"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              
              {/* Видео iframe */}
              <div className="relative pt-[56.25%]">
                <iframe
                  src={embedUrl}
                  className="absolute top-0 left-0 w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Rutube video player"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default App;